@if (negotiations$ | async; as data) {
<div class="w-full">
  <mat-card
    [ngClass]="{
      hide:
        (lot() === null && data.lot._id === undefined) ||
        data.lot._id === 'none selected' ||
        data.negotiationDetails.length === 0
    }"
  >
    <form [formGroup]="counterForm">
      <mat-card-header>
        <mat-card-title
          ><span class="font-medium text-xl">Negotiate</span></mat-card-title
        >
      </mat-card-header>
      <mat-card-content
        class="my-3 flex flex-col justify-center items-center gap-2"
      >
        @if (userDetails$ | async; as user) {
        <mat-accordion class="my-1 mx-2 my card">
          @for (ng of data.negotiationDetails; track ng) {
          <mat-expansion-panel
            (click)="selectNegotiation(ng)"
            class="my-negotiation-card selected-counter"
            [ngClass]="{ 'selected-counter': ng._id === negotiationId() }"
          >
            <mat-expansion-panel-header class="my-2">
              <mat-panel-title class="text-base">
                <div
                  style="width: 100%"
                  class="flex flex-row justify-between items-center"
                >
                  <span>
                    <span
                      [ngClass]="{
                        'greater-than':
                          activeCounter().price_value > ng.price_value_orig,
                        'less-than':
                          activeCounter().price_value < ng.price_value_orig
                      }"
                      >${{
                        ng.counters[0].price_value | priceType
                      }}&nbsp;&nbsp;&nbsp;</span
                    >
                    <span
                      >{{ ng.counters[0].volume_value }}
                      {{ ng.units }}
                    </span>
                    &nbsp;&nbsp;&nbsp; @if (ng.status === 'Declined') {
                    <mat-chip class="red-chip text-xs">Declined </mat-chip>
                    }
                    <br />
                    <span class="dark:text-gray-300 text-gray-400"
                      >{{ ng.counters[0].ship_begin | date : "MMM d, y" }} -
                      {{ ng.counters[0].ship_end | date : "MMM d, y" }}</span
                    >
                  </span>
                  <span>({{ ng.counters.length }})</span>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            @for (counter of ng.counters; track counter; let j = $index) {
            <div
              class="pb-2 px-2 my-1 text-sm"
              [ngClass]="{ 'line-through': j != 0 }"
            >
              <mat-chip
                disableRipple="true"
                class="bg-custom-blue green-chip p-0 my-2"
                [ngClass]="{
                  'green-chip': user._id === counter.originator_id,
                  'purple-chip': user._id !== counter.originator_id
                }"
                >{{
                  user._id !== counter.originator_id ? "Incoming" : "Outgoing"
                }}
              </mat-chip>
              <br />
              <div>
                <span>Price:</span> ${{
                  counter.price_value | priceType
                }}
                &nbsp;&nbsp; <span>Volume:</span> {{ counter.volume_value }}
                <span>{{ ng.units }}</span>
                <p>
                  {{ counter.ship_begin | date : "MMM d, y" }} -
                  {{ counter.ship_end | date : "MMM d, y" }}
                </p>
              </div>
            </div>
            <mat-divider></mat-divider>
            }
          </mat-expansion-panel>
          }
        </mat-accordion>
        }
        <mat-divider></mat-divider>
      </mat-card-content>
      @if (!btnStates().disableAll) {
      <mat-card-actions class="flex flex-row justify-end gap-2">
        @if (btnStates().showRevoke) {
        <button class="decline-btn" mat-raised-button (click)="revoke()">
          Revoke
        </button>
        } @if (btnStates().showDecline) {
        <button
          class="text-sm decline-btn"
          [ngClass]="{
            'disabled-btn': counterForm.disabled || btnStates().disableDecline,
            'decline-btn': !counterForm.disabled
          }"
          [disabled]="
            counterForm.disabled ||
            activeCounter().originator_id === userId() ||
            counterForm.hasError('sameValues')
          "
          (click)="decline()"
          mat-raised-button
        >
          Decline
        </button>
        }
        <button
          class="text-sm counter-btn"
          [ngClass]="{
            'counter-btn': !counterForm.disabled,
          }"
          [disabled]="
            counterForm.disabled || activeCounter().originator_id === userId()
          "
          (click)="counter()"
          mat-raised-button
        >
          Counter
        </button>
        <button
          class="text-sm accept-btn"
          [ngClass]="{
            'accept-btn': !counterForm.disabled
          }"
          [disabled]="counterForm.disabled"
          (click)="acceptNegotiation()"
          mat-raised-button
        >
          Accept
        </button>
      </mat-card-actions>
      }
      <mat-card-footer> </mat-card-footer>
    </form>
  </mat-card>
</div>
}
